var map = {
	"./en.json": "MY4V",
	"./fr.json": "SiAB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DClq";


//////////////////
// WEBPACK FOOTER
// ./src/components/language/langs nonrecursive \.json$
// module id = DClq
// module chunks = 25